import React from 'react';
import { observer, inject } from 'mobx-react';
import { withStyles, Grid, Typography, CircularProgress } from '@material-ui/core';
import Highcharts from 'highcharts';
import highchartsXrange from 'highcharts/modules/xrange';
import highchartsTimeline from 'highcharts/modules/timeline';
import HighchartsReact from 'highcharts-react-official';
import { withTranslation } from 'react-i18next';

highchartsXrange(Highcharts);
highchartsTimeline(Highcharts);

class LocationDetails extends React.Component {
  getTimelineChartLocation(locationData, uniqueNames, isDisplayXlabel) {
    const dataAcvitity = {
      chart: {
        resetZoomButton: {
          theme: {
            display: 'none',
          },
        },
        plotBorderWidth: 1,
        type: 'xrange',
        height: isDisplayXlabel ? `${uniqueNames.length * 30 + 35}px` : `${uniqueNames.length * 30 + 13}px`,
        zoomType: 'x',
        events: {
          selection: (event) => {
            if (event.originalEvent) {
              this.props.syncZoom(event, 'location');
            }
          },
        },
      },
      credits: {
        enabled: false,
      },
      title: {
        text: '',
      },
      xAxis: {
        type: 'datetime',
        visible: isDisplayXlabel,
      },
      yAxis: {
        title: {
          text: '',
        },
        categories: uniqueNames,
        reversed: true,
        labels: {
          useHTML: true,
          style: {
            minWidth: '120px',
            textAlign: 'right',
          },
        },
      },
      plotOptions: {
        series: {
          showInLegend: false,
        },
      },
      series: [
        {
          name: ' ',
          borderColor: 'gray',
          pointWidth: 20,
          data: locationData,
          dataLabels: {
            enabled: true,
          },
          turboThreshold: 0,
        },
      ],
      tooltip: {
        headerFormat: '<span style="font-size: 10px"> {point.x:%H:%M:%S } - {point.x2:%H:%M:%S }</span><br/>',
        pointFormat: `<span style="color:{point.color}">● </span> <b>{point.yCategory}</b>`,
      },
    };

    const { classes } = this.props;
    if (locationData.length > 0) {
      return (
        <Typography component='div' className={classes.locationChart}>
          <HighchartsReact highcharts={Highcharts} options={dataAcvitity} callback={this.props.dataChartLocation} />
        </Typography>
      );
    } else {
      const { t } = this.props;
      return (
        <Grid item xs={12} sm={6} md={6}>
          <Typography component='div' className={classes.noDataBox}>
            {' '}
            {t('no_data')}
          </Typography>
        </Grid>
      );
    }
  }

  getDisplayTimeXAxis = (locationData) => {
    let index = -1;

    (locationData || []).forEach((d, idx) => {
      if (d.data.length > 0) {
        index = idx;
      }
    });

    return index;
  };

  formatNumber = (num) => {
    let NEWnum;
    switch (num) {
      case undefined:
        NEWnum = 0;
        break;
      case null:
        NEWnum = 0;
        break;
      case '':
        NEWnum = 0;
        break;
      default:
        NEWnum = num;
    }
    return NEWnum.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  };

  render() {
    let { t, classes, hasLocalization } = this.props;
    const { locationData, checkingTodayData, loadingLocation, hasDataToday } = this.props.summary.toJS();
    const timeXAxisIndex = this.getDisplayTimeXAxis(locationData);

    return (
      <div className='w-screen bg-gradient-to-b from-primary-gradient to-transparent '>
        <Grid container style={{ marginBottom: 100 }}>
          <div className='flex-wrap w-full pt-3 mx-auto px-19 md:flex'>
            {this.props.zoom && (
              <div className='flex-wrap w-full pt-1 mx-auto pb-7 md:flex h-25 space-5'>
                <div className='relative items-end justify-end flex-grow text-right'>
                  <button
                    className='bottom-0 right-0 h-10 px-5 text-sm font-bold text-gray-600 border border-gray-300 rounded-lg bg-button-download '
                    onClick={this.props.resetZoom}
                  >
                    {t('reset_zoom')}
                  </button>
                </div>
              </div>
            )}

            {!checkingTodayData ? (
              !loadingLocation ? (
                <div className='w-full max-h-screen bg-white rounded md:box-content'>
                  <Grid container style={{ paddingBottom: 16 }}>
                    <Grid container>
                      {hasDataToday && hasLocalization ? (
                        <Typography component='div' style={{ width: '100%' }}>
                          {(locationData || []).map((d, index) => (
                            <div key={index}>
                              <Grid container spacing={8}>
                                <Grid item md={6} sm={6} xs={6}>
                                  <Typography component='div' className={classes.title}>
                                    {t('device_name')}: {d.deviceName} {d.data.length === 0 ? ` (${t('no_data')})` : ''}
                                  </Typography>
                                </Grid>
                                {localStorage.getItem('role_id') === '1' && d.data.length > 0 && (
                                  <Grid container item md={6} sm={6} xs={6} className={classes.gridMessage}>
                                    <Typography className={classes.titleMessage}>
                                      {this.formatNumber(d.deviceMessageCount)}
                                    </Typography>
                                    <Typography variant='caption' className={classes.captionMessages}>
                                      {t('messages')}
                                    </Typography>
                                  </Grid>
                                )}
                              </Grid>
                              {d.data &&
                                d.data.length > 0 &&
                                this.getTimelineChartLocation(
                                  d.data,
                                  d.uniqueNames,
                                  timeXAxisIndex >= 0 && timeXAxisIndex === index,
                                )}
                            </div>
                          ))}
                        </Typography>
                      ) : (
                        <Typography component='div' className={classes.noDataBox}>
                          {' '}
                          {t('no_data')}
                        </Typography>
                      )}
                    </Grid>
                  </Grid>
                </div>
              ) : (
                <div className='flex justify-center w-full text-center'>
                  <div className='flex mt-4'>
                    <CircularProgress size={26} />
                    <div className='px-5 pt-0.5  text-gray-600 text-base'>{t('loading')}</div>
                  </div>
                </div>
              )
            ) : (
              ''
            )}

            {/* <div className="w-full max-h-screen bg-white rounded md:box-content">
              <Grid container style={{ paddingBottom: 16 }}>
                {!checkingTodayData ? (
                  <Grid container>
                    {hasDataToday && hasLocalization ? (
                      <Typography component="div" style={{ width: "100%" }}>
                        {loadingLocation ? (
                          <div className={classes.textLoading}>
                            {" "}
                            {t("loading")}
                          </div>
                        ) : (
                          (locationData || []).map((d, index) => (
                            <div key={index}>
                              <Grid container spacing={2}>
                                <Grid item md={6} sm={6} xs={6}>
                                  <Typography
                                    component="div"
                                    className={classes.title}
                                  >
                                    {t("device_name")}: {d.deviceName}{" "}
                                    {d.data.length === 0
                                      ? ` (${t("no_data")})`
                                      : ""}
                                  </Typography>
                                </Grid>
                                {localStorage.getItem("role_id") === "1" &&
                                  d.data.length > 0 && (
                                    <Grid
                                      container
                                      item
                                      md={6}
                                      sm={6}
                                      xs={6}
                                      className={classes.gridMessage}
                                    >
                                      <Typography
                                        className={classes.titleMessage}
                                      >
                                        {this.formatNumber(
                                          d.deviceMessageCount
                                        )}
                                      </Typography>
                                      <Typography
                                        variant="caption"
                                        className={classes.captionMessages}
                                      >
                                        {t("messages")}
                                      </Typography>
                                    </Grid>
                                  )}
                              </Grid>
                              {d.data &&
                                d.data.length > 0 &&
                                this.getTimelineChartLocation(
                                  d.data,
                                  d.uniqueNames,
                                  timeXAxisIndex >= 0 &&
                                    timeXAxisIndex === index
                                )}
                            </div>
                          ))
                        )}
                      </Typography>
                    ) : (
                      <Typography component="div" className={classes.noDataBox}>
                        {" "}
                        {t("no_data")}
                      </Typography>
                    )}
                  </Grid>
                ) : (
                  ""
                )}
              </Grid>
            </div> */}
          </div>
        </Grid>
      </div>
    );
  }
}

const styles = (theme) => ({
  textLoading: {
    fontSize: '18px',
    textAlign: 'center',
    marginTop: '20px',
    padding: 8 * 3,
  },
  locationChart: {
    width: '100%',
    paddingTop: '10px',
    maxHeight: '500px',
    // overflowY: "scroll",
  },
  noDataBox: {
    padding: 8 * 3,
    fontSize: 16,
    fontFamily: 'kanit',
    fontWeight: 600,
    color: theme.palette.text.header,
  },
  title: {
    paddingLeft: 30,
    paddingTop: 15,
    fontSize: 16,
    fontFamily: 'kanit',
    fontWeight: 600,
    color: theme.palette.text.header,
  },
  gridMessage: {
    display: 'flex',
    justifyContent: 'right',
    paddingLeft: 5,
    paddingTop: 20,
    paddingRight: 12,
  },
  titleMessage: {
    marginRight: 5,
    fontSize: 12,
    fontFamily: 'kanit',
    fontWeight: 900,
  },
  captionMessages: {
    fontFamily: 'kanit',
  },
});
export const page = inject('summary')(observer(LocationDetails));
export const translation = withTranslation()(page);
export default withStyles(styles, { withTheme: true })(translation);
